const eeRegistryDSN = 'https://f31bc3de5f7f4f5290342dccc141bf4d@sentry-next.wixpress.com/3666';
export default class SentryReporter {
    constructor(host, getSentryClient, options = {
        dsn: eeRegistryDSN,
        tracesSampleRate: 1.0,
    }) {
        this.host = host;
        this.getSentryClient = getSentryClient;
        this.options = options;
    }
    async captureException(exception, hint) {
        // getSentryClient is optional - to support backward compatibility for the hosts
        if (!this.getSentryClient) {
            return;
        }
        const { captureContext } = (hint || {});
        const enrichedHint = {
            ...hint,
            captureContext: {
                ...captureContext,
                tags: {
                    ...captureContext?.tags,
                    host: this.host,
                },
            },
        };
        this.sentryClient =
            this.sentryClient ?? this.getSentryClient?.(this.options);
        if (!this.sentryClient || !this.sentryClient.captureException) {
            console.log('Passed argument getSentry does not yield a valid Sentry instance');
            return;
        }
        this.sentryClient.captureException(exception, enrichedHint);
    }
}
//# sourceMappingURL=sentry.js.map